<template>
	<div class="flex flex-col text-sm leading-tight items-start font-open-sans" :class="{'md:grid-cols-2': layout === 'modal'}">
		<section v-if="order && step > navigation.getIndexStep(product.product_type, OrderStepType.PAYMENT)" class="p-6 border border-box-white-200 bg-box-white w-full">
			<h3 class="font-bold text-xl mb-3">Dados de compra</h3>
			<p class="mb-3">
				<b>Número do pedido:</b><br /> 
				<span class="text-xl text-primary font-bold">{{ order?.sku }}</span>
			</p>
			<p v-if="!!order.ordered_at">
				<b>Data:</b> 
				<span class="text-primary">{{ formatDateToDDMMYYYY(order.ordered_at) }}</span>
			</p>
			<p v-if="!!order.payment_type">
				<b>Método de pagamento:</b> 
				<span class="text-primary">{{ getPaymentTypeText(order.payment_type) }}</span>
			</p>
		</section>
		<section class="p-6 items-start w-full">
			<div class="mb-3">
				<NuxtImg class="bg-white rounded-lg border max-w-[84px] p-2 border-gray-300" :src="product?.institution.logo"></NuxtImg>
			</div>
			<div class="mt-3 mb-4">
				<h2 class="text-xs font-semibold">{{ product?.academic_level?.name }}</h2>
				<h3 class="text-2xl font-bold">{{ product?.title }}</h3>
			</div>
			<div class="rounded-lg bg-primary text-white font-semibold px-2 py-1 mb-4 inline-block ">
				<p class="flex">
					<Icon class="text-green-400 mt-0 text-md" icon="tabler:arrow-down" /> 
					Bolsa de <span class="text-green-400 font-bold ml-1 mr-1">{{ product?.discount }}% </span> pela faculdade
				</p>				
			</div>
			<ResumeProduct />
			<div class="border-gray-400 boder">
				<div class="p-3 bg-yellow-400 rounded-tl-md rounded-tr-md">
					<h2 class="text-black font-bold text-xl">
						{{ step <= navigation.getIndexStep(product.product_type, OrderStepType.PAYMENT) ? OrderCheckoutTypeTagName.PREPAID_GUARANTEE : OrderCheckoutTypeTagName.PREPAID_FINISHED }}
					</h2>
				</div>
				<div>
					<div class="p-4 bg-white text-left">
						<p class="font-bold text-base mb-1">
							{{ step <= navigation.getIndexStep(product.product_type, OrderStepType.PAYMENT) 
								? 'Sua mensalidade ficará'
								: 'Sua mensalidade ficou:'  }}							
						</p>
						<p>
							<Icon class="text-green-400 mt-0 text-md inline-block" icon="tabler:arrow-down" />
							<span class="text-2xl font-bold">R$ {{ usePrice(product?.sale_price) }}</span>
							<span class="text-base font-bold">/mês</span>
							<span class="text-xs ml-2">Antes <span class="line-through">R${{ usePrice(product?.regular_price) }}/mês</span></span>
						</p>
						<p v-if="!product.is_full_period_discount">{{ product.discount_period }}</p>
					</div>
					<div v-if="step < navigation.getIndexStep(product.product_type, OrderStepType.PAYMENT)" class="bg-white flex rounded-bl-md rounded-br-md p-3 items-start">
						<span class="bg-white rounded-full mr-3">
							<Icon icon="zondicons:exclamation-solid" class="text-yellow-400 text-2xl" />
						</span>
						
						<div class="">
							<h4 class="font-bold">APENAS 3 BOLSAS DISPONÍVEIS</h4>
							<p class="text-xs text-gray-400">Altas chances da bolsa esgotar logo</p>
						</div>
					</div>
					<OfferBoxTime 
						class="hidden sm:block"
						v-if="step === navigation.getIndexStep(product.product_type, OrderStepType.PAYMENT)">
					</OfferBoxTime>
					<div v-else class="bg-gray-light flex rounded-bl-md rounded-br-md p-3 items-center" v-if="product?.saved_amount">
						<p class="text-black font-bold text-right leading-6 text-xs w-5/12">Economia total no final do curso:</p>
						<p class="font-extrabold text-2xl pl-3 text-blue-400">R$ {{ usePrice(product?.saved_amount) }}</p>
					</div>
				</div>
			</div>			
		</section>
	</div>
</template>

<script lang="ts" setup>
	import { formatDateToDDMMYYYY } from '~/utils/formats';
	import { storeCoupon } from "~/store/coupon";
	import { usePrice } from "~/composables/usePrice";
	import { useCheckoutStore } from "~/store/checkout";
	import { storeToRefs } from "pinia";
	import { Icon } from "@iconify/vue";
	import { OrderCheckoutTypeTagName } from "~~/enums/orderCheckoutType";
	import { getPaymentTypeText } from "~~/enums/paymentTypes";
	import ResumeProduct from "~/components/common/product-review/resume-product.vue";
	import { useNavigationStore } from "~~/store/navigation";
	import { OrderStepType } from "~~/enums/orderStepType";

	const couponStore = storeCoupon();

	const checkout = useCheckoutStore();
	const step: any = useState("step");
	const navigation = useNavigationStore();

	const { order, product } = storeToRefs(checkout);

	const { layout, hasAction } = defineProps({
		hasAction: {
			type: Boolean,
			default: () => true
		},
		layout: {
			type: String,
			default: () => "default",
		}
	});

	const emit = defineEmits(["onClick"]);

	const discount_code = ref(null);

	if (process.client) {
		const coupon = couponStore.coupon || {};
		if (!!coupon.discount && !!couponStore.code) {
			discount_code.value = await couponStore.calculate(product.value.id).catch(() => null);
		}
	}

</script>
